import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS as LMSEndpoints } from '../../../Utils/Endpoints';
import { ENDPOINTS as SecEndpoints } from '../../../../Seguridad/Utils/Endpoints';

const EMPTY = {
    idCurso: '',
    idPuesto: '',
    fechaLimite: '',
    activo: true,
};

export default function Modal({
    open,
    mode = 'new',
    data = null,
    onClose,
    onSubmit,
    inline = false,
}) {
    const [form, setForm] = useState(EMPTY);
    const [errors, setErrors] = useState({});
    const [cursos, setCursos] = useState([]);
    const [puestos, setPuestos] = useState([]);
    const [loadingExtras, setLoadingExtras] = useState(false);

    useEffect(() => {
        if (open) {
            loadExtras();
        }
    }, [open]);

    const loadExtras = async () => {
        setLoadingExtras(true);
        try {
            const [resCursos, resPuestos] = await Promise.all([
                axios.get(LMSEndpoints.cursos),
                axios.get(SecEndpoints.puestos)
            ]);
            setCursos((resCursos.data || [])
                .filter(c => c.terminado || c.Terminado)
                .map(c => ({ idCurso: c.idCurso ?? c.IdCurso, nombre: c.nombre ?? c.Nombre })));
            setPuestos((resPuestos.data || []).map(p => ({ idPuesto: p.idPuesto ?? p.IdPuesto, nombre: p.nombre ?? p.Nombre })));
        } catch (e) {
            console.error('Error al cargar catálogos:', e);
        } finally {
            setLoadingExtras(false);
        }
    };

    const validateField = (field, value) => {
        let error = '';
        if (field !== 'fechaLimite' && !value) {
            error = 'Este campo es obligatorio.';
        }
        setErrors(prev => ({ ...prev, [field]: error }));
    };

    const validateAll = () => {
        const newErrors = {};
        let isValid = true;
        Object.keys(EMPTY).forEach(key => {
            if (key !== 'activo' && key !== 'fechaLimite' && !form[key]) {
                newErrors[key] = 'Este campo es obligatorio.';
                isValid = false;
            }
        });
        setErrors(newErrors);
        return isValid;
    };

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
        validateField(field, value);
    };

    useEffect(() => {
        if (mode === 'edit' && data) {
            setForm({
                idAsignacionMasivaPuesto: data.idAsignacionMasivaPuesto,
                idCurso: data.idCurso || '',
                idPuesto: data.idPuesto || '',
                fechaLimite: data.fechaLimite ? data.fechaLimite.substring(0, 10) : '',
                activo: data.activo ?? true
            });
        } else {
            setForm(EMPTY);
            setErrors({});
        }
    }, [mode, data]);

    if (!open) return null;

    const errorStyle = { color: '#b91c1c', fontSize: '.8rem', display: 'block', marginTop: '4px' };

    const Header = (
        <div className="roles-topbar" style={{ marginBottom: '0.6rem', paddingRight: 16, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: '0 0 auto' }}>
            <h3 className="roles-title" style={{ marginRight: 0 }}>
                {mode === 'new' ? 'Nueva Asignación Masiva por Puesto' : 'Editar Asignación Masiva por Puesto'}
            </h3>
            <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
        </div>
    );

    const Body = (
        <div style={{ paddingLeft: '12%', paddingRight: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.8rem', overflowY: 'auto', flex: '1 1 auto', minHeight: 0 }}>

            <div style={{ gridColumn: '1 / 3' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Curso: <span style={{ color: 'red' }}>*</span></label>
                <br /><br />
                <select
                    className={`infoField${errors.idCurso ? ' infoField--error' : ''}`}
                    value={form.idCurso}
                    onChange={(e) => handleChange('idCurso', e.target.value)}
                >
                    <option key="default" value="">Seleccione un curso...</option>
                    {cursos.map(c => (
                        <option key={c.idCurso} value={c.idCurso}>{c.nombre}</option>
                    ))}
                </select>
                {errors.idCurso && <small style={errorStyle}>{errors.idCurso}</small>}
            </div>

            <div style={{ gridColumn: '1 / 3' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Puesto: <span style={{ color: 'red' }}>*</span></label>
                <br /><br />
                <select
                    className={`infoField${errors.idPuesto ? ' infoField--error' : ''}`}
                    value={form.idPuesto}
                    onChange={(e) => handleChange('idPuesto', e.target.value)}
                >
                    <option key="default" value="">Seleccione un puesto...</option>
                    {puestos.map(p => (
                        <option key={p.idPuesto} value={p.idPuesto}>{p.nombre}</option>
                    ))}
                </select>
                {errors.idPuesto && <small style={errorStyle}>{errors.idPuesto}</small>}
            </div>

            <div style={{ gridColumn: '1 / 3' }}>
                <label className="roles-title" style={{ fontSize: '.95rem' }}>Fecha Límite:</label>
                <br /><br />
                <input
                    type="date"
                    className={`infoField${errors.fechaLimite ? ' infoField--error' : ''}`}
                    value={form.fechaLimite}
                    onChange={(e) => handleChange('fechaLimite', e.target.value)}
                />
                {errors.fechaLimite && <small style={errorStyle}>{errors.fechaLimite}</small>}
            </div>

        </div>
    );

    const Footer = (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '.6rem', marginTop: '.8rem', paddingRight: 16, flex: '0 0 auto' }}>
            <button className="roles-btn" onClick={onClose}>Cancelar</button>
            <button
                className="btn-action"
                onClick={() => {
                    if (validateAll()) {
                        onSubmit(form, mode);
                    }
                }}
                disabled={loadingExtras}
            >
                {mode === 'new' ? 'Guardar' : 'Actualizar'}
            </button>
        </div>
    );

    if (inline) {
        return (
            <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                {Header}
                {Body}
                {Footer}
            </div>
        );
    }

    return (
        <div
            className="roles-confirm-overlay"
            role="dialog"
            aria-modal="true"
            style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 1000 }}
            onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        >
            <div
                className="roles-confirm-card"
                style={{ width: 'min(700px, 96vw)', maxHeight: '85vh', background: '#fff', borderRadius: 12, boxShadow: '0 10px 30px rgba(0,0,0,.25)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
            >
                {Header}
                {Body}
                {Footer}
            </div>
        </div>
    );
}
